/* eslint-disable import/no-anonymous-default-export */
export default {
    AGENT: 'AGENT',
    CLIENT: 'CLIENT',
    INDIVIDUAL: 'INDIVIDUAL',
    BUSINESS: 'BUSINESS',
    CLIENT_LEVEL: 'CLIENT_LEVEL',
    ORDER_LEVEL: 'ORDER_LEVEL',
    NGO: 'NGO',
    ACTIVE: 'ACTIVE',
    PROMOTED: 'PROMOTED',
    EDIT: 'Edit',
    VIEW: 'View',
    DEV: 'Dev',
    ADMIN: 'Admin',
    ACCOUNT_MANAGER: 'Account Manager',
    EMPLOYEE: 'Employee',
    ARTICLESHIP: 'ArticleShip',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED'
};

export const module_stats_types = {
    SERVICE_MANAGEMENT: 'service_mng',
    CLIENT_MANAGEMENT: 'client_mng',
    EMPLOYEE_MANAGEMENT: 'employee_mng',
    DEPARTMENT_MANAGEMENT: 'department_mng',
    ORDERS_AND_TRXNS: 'orders_and_txns',
    VAULT_MANAGEMENT: 'vault_mng'
};

export const vault_category_types = {
    WEBSITE: 'Website',
    PAYMENT_CARD: 'Payment Card',
    SERVICE_NOTE: 'Service Note'
};

export const vault_tag_types = {
    MCA_PORTAL: 'MCA Portal',
    INCOME_TAX_PORTAL: 'Income Tax Portal',
    GST_PORTAL: 'GST Portal',
    OTHERS: 'Others'
};

export const refund_statuses = {
    PROCESSED: 'Processed',
    FAILED: 'Failed',
    PENDING: 'Pending'
};

export const frequencyOptions = [
    {
        label: 'Daily',
        value: 'DAILY'
    },
    {
        label: 'Weekly',
        value: 'WEEKLY'
    },
    {
        label: 'Monthly',
        value: 'MONTHLY'
    },
    {
        label: 'Quaterly',
        value: 'QUATERLY'
    },
    {
        label: 'Half Yearly',
        value: 'HALF_YEARLY'
    },
    {
        label: 'Annual',
        value: 'YEARLY'
    },
]

export const daysOptions = [
    { label: 'Monday', value: 'MONDAY' },
    { label: 'Tuesday', value: 'TUESDAY' },
    { label: 'Wednesday', value: 'WEDNESDAY' },
    { label: 'Thursday', value: 'THURSDAY' },
    { label: 'Friday', value: 'FRIDAY' },
    { label: 'Saturday', value: 'SATURDAY' },
    { label: 'Sunday', value: 'SUNDAY' },
];

export const refer_mng_services_status = {
    active: 'Pending',
    inprogress: 'Pending',
    completed: 'Successful',
    closed: 'Closed'
};

export const clientTypeOptions = [
    { value: 'ALL', label: 'All Client Types' },
    { value: 'INDIVIDUAL', label: 'Individual' },
    { value: 'BUSINESS', label: 'Business' }
  ];

export const clientStatusOptions = [
    { value: 'ALL', label: 'All Status' },
    { value: 'ACTIVE', label: 'Active' },
    { value: 'INACTIVE', label: 'In Active' }
  ];

export const roleTypeOptions = [
    { value: 'ALL', label: 'All Access Types' },
    { value: 'CLIENT_LEVEL', label: 'Client Access' },
    { value: 'ORDER_LEVEL', label: 'Order Access' }
  ];

export const roleAccessTypes = {
    CLIENT_LEVEL: 'Client Access',
    ORDER_LEVEL: 'Order Access',
}

export const refer_withdrawl_status = {
  PENDING: {
    label: "Pending",
    color: "#DBB681",  // Yellow
    backgroundColor: "#FBF7D9",
  },
  ACCEPTED: {
    label: "Accepted",
    color: "#519A7D",        // Green
    backgroundColor: "#E9F2ED"
  },
  COMPLETED: {
    label: "Successful",
    color: "#519A7D",
    backgroundColor: "#E9F2ED",
  },
  SUCCESSFULL: { // duplicate of COMPLETED
    label: "Successful",
    color: "#519A7D",
    backgroundColor: "#E9F2ED",
  },
  REJECTED: {
    label: "Rejected",
    color: "#FF0000",        // Red
    backgroundColor: "#FEECDE",
  },
  CANCELLED: {
    label: "Cancelled",
    color: "#FF0000",
    backgroundColor: "#FEECDE",
  },
  HOLD: {
    label: "On Hold",
    color: "#82783B",        // Darker orange for contrast
    backgroundColor: "#EDEBDC"
  },
};

export const employeeRoleTypes = {
    CLIENT_LEVEL: 'Client Access',
    ORDER_LEVEL: 'Order Access',
};

export const clientStatus = {
    ACTIVE: 'Active',
    INACTIVE: 'In Active',
};

export const userServiceStatus = {
    active: 'Active',
    inprogress: 'In Progress',
    completed: 'Completed',
    closed: 'Closed'
};

export const COOKIE_KEYS = {
    TOKEN: 'token',
    REFRESH_TOKEN: 'refresh_token',
    USER_ID: 'userId',
    USER_TYPE: 'userType',
    USER_NAME: 'user_name',
    EMAIL: 'email',
    MOBILE: 'mobile',
    MOBILE_VERIFIED: 'mobileVerified',
    ROLE_ID: 'roleID',
    ROLE_NAME: 'roleName',
    ROLE_LEVEL: 'role_level',
    ROLE_TYPE: 'role_type',
    SESSION_TIMEOUT: 'sessionTimeout',
    LOCK_ENABLED: 'lockEnabled',
    APP_LOCKED: 'app_locked',
    IS_LAST_LEVEL_IN_CLIENT_LEVEL: 'isLastLevelInClientLevel',
    IS_LAST_LEVEL_IN_ORDER_LEVEL: 'isLastLevelInOrderLevel',
    ASSIGNED_ACCOUNT_MANAGER_ID: 'assignedAccountManagerID',
    USER_CATEGORY: 'userCategory',
    BUSINESS_TYPE: 'businessType',
    REFERRAL_CODE: 'referalCode',
    IS_NEW_USER: 'isNewUser',
    INACTIVE_USER: 'inActiveUser',
    LAST_LOGGED_IN_AT: 'lastLoggedInAt',
};

export const SETTINGS_KEYS = {
    ACCOUNT_SECURITY: 'account-security',
    LOGIN: 'login',
    CONNECTED_SIGNIN: 'connected-signin',
    CHANGE_PASSWORD: 'change-password',
    MFA: 'mfa',
    AUTO_LOGOUT: 'auto-logout',
    LOCK_SCREEN: 'lock-screen',
    ACCESS_CONTROL: 'access-control',
    ROLE_MANAGEMENT: 'role-management',
    BANKS_PAYMENTS: 'banks-payments',
    UPI: 'upi',
    NOTIFICATIONS: 'notifications',
    NOTIFICATION_PREFERENCES: 'notification-preferences',
    COMPANY_PROFILE: 'company-profile',
    PRIMARY_DETAILS: 'primary-details',
    COMPANY_DETAILS: 'company-details',
    OTHER_DETAILS: 'other-details',
    MARKETING: 'marketing',
    BANNER_MANAGEMENT: 'banner-management',
};

export const ROUTES = {
    SETTINGS: '/settings',
    DASHBOARD: '/dashboard',
};